<template>
  <div class='address'>
    <!-- <van-nav-bar title="我的收货地址"
                 right-text="添加"
                 left-arrow
                 @click-left="onClickLeft"
                 @click-right="onClickRight" /> -->
    <!-- <div @click="onClickRight">
      <button>添加</button>
    </div> -->
    <van-address-list v-model="chosenAddressId"
                      :list="list"
                      :disabled-list="disabledList"
                      disabled-text="以下地址超出配送范围"
                      @add="onAdd"
                      @edit="onEdit" />
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: 'addressList',
  data () {
    return {
      chosenAddressId: '1',
      list: [
      ],
      //不可编辑的
      disabledList: [

      ],
      targetIndex: 0,
      targetAddress: {} //传值的新对象
    }
  },
  mounted () {
    this.list = this.$store.state.addressList;

    window['newAddress'] = () => {
      this.onClickRight();
    }
  },
  methods: {
    onAdd () {
      this.$router.push('/addAddress/0/0');
    },
    onEdit (item, index) {
      // //debugger
      //区分编辑和修改
      this.$router.push('/addAddress/1/0');
      this.targetAddress = item;
      this.$store.commit('getTargetAddress', item);
      console.log(this.$store.state.targetAddress);
    },
    //返回
    onClickLeft () {
      //this.$router.push('/my');
      debugger
    },
    //跳转到添加的页面
    onClickRight () {
      //新增页面
      this.$router.push('/addAddress/0/0');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/address/addressList.vue